import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleChat, addUserMessage } from '../../store/actions';
import { isWidgetOpened } from '../../store/dispatcher';

import WidgetLayout from './layout';
import WebSocketManager from '../../../../manager/WebSocketManager';
import { checkUserId, delay, getUserId, local, removeUserId } from '../../../../utils/helper';
import { getUUID } from '../../../../utils/uuid';
import ConsoleUtils from '../../../../utils/console';

const webSocketManager = new WebSocketManager();

function Widget({
  title,
  titleAvatar,
  subtitle,
  senderPlaceHolder,
  profileAvatar,
  profileClientAvatar,
  showCloseButton,
  fullScreenMode,
  autofocus,
  customLauncher,
  handleNewUserMessage,
  config,
  handleQuickButtonClicked,
  handleTextInputChange,
  chatId,
  handleToggle,
  launcherOpenLabel,
  launcherCloseLabel,
  launcherCloseImg,
  launcherOpenImg,
  sendButtonAlt,
  showTimeStamp,
  imagePreview,
  zoomStep,
  handleSubmit,
  showBadge,
  resizable,
  emojis, showStartScreen, onSubmit, onFormSubmit
}) {
  const { widgetConfig } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
  }));
  const dispatch = useDispatch();

  const connectSocket = () => {
    onFormSubmit(false);
    delay(500);
    
    const messageToSend = {
      id: getUUID(),
      payloadType: "event",
      type: "startSession"
    };
    webSocketManager.send(messageToSend);  
  }

  useEffect(async () => {    
    if(!widgetConfig?.widgetConfig?.isSessionAvailable && !widgetConfig?.widgetConfig?.preChatSurvey?.display){
      connectSocket();
    }

    webSocketManager.addListener('open', startSessionMessageSend);
    return () => {
      webSocketManager.removeListener('open', startSessionMessageSend);
    };
  }, [])

  const startSessionMessageSend = () => {
    // delay(500);
    // if(checkUserId(config.widgetId) && messages.length > 0) {
    //   const messageToSend = {
    //     id: getUUID(),
    //     payloadType: "event",
    //     type: "startSession"
    //   };
    //   webSocketManager.send(messageToSend);        
    // }
  }

  const toggleConversation = () => {
    dispatch(toggleChat());
    if (handleToggle) {
      handleToggle(isWidgetOpened());
    }
  };

  const handleMessageSubmit = (userInput) => {
    if (typeof userInput === 'object') {
      ConsoleUtils.log('Image object', userInput);
    } else {
      if (!userInput.trim()) {
        return;
      }
    }
    handleSubmit(userInput);
    dispatch(addUserMessage(userInput));
    // handleNewUserMessage(userInput);
  };
  const onQuickButtonClicked = (event, value) => {
    event.preventDefault();
    handleQuickButtonClicked(value);
  };

  return (
    <WidgetLayout
      onToggleConversation={toggleConversation}
      onSendMessage={handleMessageSubmit}
      onQuickButtonClicked={onQuickButtonClicked}
      title={title}
      titleAvatar={titleAvatar}
      subtitle={subtitle}
      senderPlaceHolder={senderPlaceHolder}
      profileAvatar={profileAvatar}
      profileClientAvatar={profileClientAvatar}
      showCloseButton={showCloseButton}
      fullScreenMode={fullScreenMode}
      autofocus={autofocus}
      customLauncher={customLauncher}
      onTextInputChange={handleTextInputChange}
      chatId={chatId}
      config={config}
      launcherOpenLabel={launcherOpenLabel}
      launcherCloseLabel={launcherCloseLabel}
      launcherCloseImg={launcherCloseImg}
      launcherOpenImg={launcherOpenImg}
      sendButtonAlt={sendButtonAlt}
      showTimeStamp={showTimeStamp}
      imagePreview={imagePreview}
      zoomStep={zoomStep}
      showBadge={showBadge}
      resizable={resizable}
      emojis={emojis}
      showStartScreen={showStartScreen}
      onSubmit={onSubmit}
    />
  );
}

export default Widget;
